import { AddonCategory } from 'src/store/addon/types';
import { IClipArtResultCategory } from 'src/store/addon/types/clipArtTypes';
import clipArtToAddon from './clipArtToAddon';

const clipArtCategoryToAddonCategory = (
  clipArtCategory: IClipArtResultCategory,
  parentCategoryId: string | null,
  getPrice: (productId: number) => string,
): AddonCategory => ({
  id: String(clipArtCategory.clipArtCategoryId),
  parentId: parentCategoryId ? String(parentCategoryId) : undefined,
  name: clipArtCategory.title,
  subcategories: clipArtCategory.subCategories?.map((clipArtCat) => clipArtCategoryToAddonCategory(clipArtCat, clipArtCategory.clipArtCategoryId, getPrice)),
  elements: clipArtCategory.clipArts ? clipArtCategory.clipArts.map((clipArt) => clipArtToAddon(clipArt, getPrice)) : [],
  count: clipArtCategory.clipArts ? clipArtCategory.clipArts.length : 0,
});

export default clipArtCategoryToAddonCategory;
